export const words = [
	'ABOUT',
	'ABOVE',
	'AMONG',
	'ADULT',
	'ANGRY',
	'ARRAY',
	'ABUSE',
	'ADMIT',
	'AGENT',
	'ALBUM',
	'ALONE',
	'ANGER',
	'APART',
	'ARENA',
	'APPLE',
	'ALLOW',
	'AUDIO',
	'ACUTE',
	'BLOOD',
	'BEGAN',
	'BELOW',
	'BOOST',
	'BEACH',
	'BLACK',
	'BLOOD',
	'BOOTH',
	'BOARD',
	'BREAD',
	'BREAK',
	'BUYER',
	'BLIND',
	'BLAME',
	'BROWN',
	'BROAD',
	'BUILT',
	'BROKE',
	'BIRTH',
	'CHEAP',
	'CABLE',
	'CHART',
	'CHILD',
	'CLEAN',
	'CLOCK',
	'COUNT',
	'CLEAN',
	'CHART',
	'CHECK',
	'CHOSE',
	'CHIEF',
	'CLICK',
	'CLASS',
	'CLEAR',
	'CLAIM',
	'CLOSE',
	'CLEAR',
	'COURT',
	'CRASH',
	'CROSS',
	'CURVE',
	'DAILY',
	'DANCE',
	'DREAM',
	'DOZEN',
	'DRAWN',
	'DRAMA',
	'DROVE',
	'DEPTH',
	'DEBUT',
	'DOING',
	'DRAFT',
	'DATED',
	'DRINK',
	'DELAY',
	'DRAMA',
	'DRESS',
	'ENEMY',
	'ENJOY',
	'EIGHT',
	'ENTER',
	'EVENT',
	'EXIST',
	'EXACT',
	'EQUAL',
	'FLOOR',
	'FIXED',
	'FORTH',
	'FORUM',
	'FRANK',
	'FORCE',
	'FUNNY',
	'FIELD',
	'FIBER',
	'FIFTY',
	'FIRST',
	'FLOOR',
	'FORCE',
	'FRANK',
	'FRAUD',
	'FRONT',
	'FRAME',
	'FRUIT',
	'FULLY',
	'GLASS',
	'GUEST',
	'GUARD',
	'GROWN',
	'GUESS',
	'GLOBE',
	'GOING',
	'GRACE',
	'GRADE',
	'GREEN',
	'GROSS',
	'GROUP',
	'GUIDE',
	'HOUSE',
	'HOTEL',
	'HAPPY',
	'HARRY',
	'HEART',
	'HEAVY',
	'HENCE',
	'HENRY',
	'HORSE',
	'HOTEL',
	'HOUSE',
	'HUMAN',
	'IDEAL',
	'IMAGE',
	'INDEX',
	'INNER',
	'INPUT',
	'ISSUE',
	'JAPAN',
	'JONES',
	'JOINT',
	'JIMMY',
	'JUDGE',
	'KNOWN',
	'LATER',
	'LAUGH',
	'LARGE',
	'LEASE',
	'LEAST',
	'LEVEL',
	'LANDS',
	'LEARN',
	'LEASE',
	'LEAVE',
	'LEGAL',
	'LEVEL',
	'LEWIS',
	'LIGHT',
	'LIMIT',
	'LINKS',
	'LIVES',
	'LOCAL',
	'LOGIC',
	'LOOSE',
	'LOWER',
	'LUCKY',
	'LUNCH',
	'LYING',
	'MAJOR',
	'MAGIC',
	'MARCH',
	'MAYBE',
	'MATCH',
	'MEDIA',
	'METAL',
	'MODEL',
	'MONTH',
	'MOUNT',
	'MANGO',
	'MOUSE',
	'MORAL',
	'MOVIE',
	'MINUS',
	'MIXED',
	'MOTOR',
	'MOUTH',
	'NIGHT',
	'NORTH',
	'NURSE',
	'NEEDS',
	'NEVER',
	'NEWLY',
	'NIGHT',
	'NOISE',
	'NOTED',
	'NOVEL',
	'OTHER',
	'OFTEN',
	'ORDER',
	'OCCUR',
	'OCEAN',
	'OFFER',
	'OUGHT',
	'PANEL',
	'PAPER',
	'PEACE',
	'PARTY',
	'PHONE',
	'PHOTO',
	'PILOT',
	'PRIDE',
	'POWER',
	'PROUD',
	'POUND',
	'PIECE',
	'PLAIN',
	'PLANE',
	'PLANT',
	'PLATE',
	'POINT',
	'PRESS',
	'PRICE',
	'PRIDE',
	'PRIME',
	'PRINT',
	'PRIOR',
	'PRIZE',
	'PROOF',
	'QUEEN',
	'QUICK',
	'QUIET',
	'QUITE',
	'RADIO',
	'RAPID',
	'READY',
	'RATIO',
	'RIVAL',
	'RIVER',
	'RIGHT',
	'ROUTE',
	'RAISE',
	'ROGER',
	'ROBIN',
	'ROMAN',
	'ROUTE',
	'ROYAL',
	'RURAL',
	'SCOPE',
	'SHARP',
	'SHOOT',
	'SINCE',
	'SHORT',
	'SIGHT',
	'SIXTH',
	'SKILL',
	'SMALL',
	'SLEEP',
	'SPLIT',
	'STAFF',
	'STAGE',
	'START',
	'SCENE',
	'SCORE',
	'SENSE',
	'SERVE',
	'SEVEN',
	'SHALL',
	'SHAPE',
	'SHARE',
	'SHARP',
	'SHEET',
	'SHELF',
	'SHELL',
	'SHIFT',
	'SHIRT',
	'SHOCK',
	'SHOOT',
	'SHORT',
	'SHOWN',
	'SIGHT',
	'SINCE',
	'SIXTH',
	'SIXTY',
	'SIZED',
	'SLIDE',
	'SMALL',
	'SMART',
	'SMILE',
	'SMITH',
	'SMOKE',
	'SOLID',
	'SOLVE',
	'SORRY',
	'SOUND',
	'SPARE',
	'SPEAK',
	'SPEED',
	'SPEND',
	'SPENT',
	'SPLIT',
	'SPOKE',
	'SPORT',
	'STAFF',
	'STAGE',
	'STAKE',
	'STAND',
	'START',
	'STATE',
	'STEAM',
	'STEEL',
	'STICK',
	'STILL',
	'STOCK',
	'STONE',
	'TEETH',
	'THANK',
	'THEME',
	'THIRD',
	'THREW',
	'TIRED',
	'TOPIC',
	'TOUCH',
	'TEACH',
	'TEXAS',
	'THICK',
	'THIRD',
	'THING',
	'THERE',
	'TIRED',
	'THEIR',
	'TOPIC',
	'TODAY',
	'TOUGH',
	'TOWER',
	'TOTAL',
	'TRADE',
	'UNDER',
	'UNITY',
	'UPSET',
	'USAGE',
	'UPPER',
	'UNION',
	'URBAN',
	'UNTIL',
	'USUAL',
	'UNDUE',
	'VALUE',
	'VISIT',
	'VITAL',
	'VOICE',
	'WASTE',
	'WATCH',
	'WATER',
	'WHEEL',
	'WHILE',
	'WASTE',
	'WHITE',
	'WOMAN',
	'WORLD',
	'WORST',
	'WORSE',
	'WORRY',
	'WOUND',
	'WRITE',
	'WORTH',
	'WROTE',
	'WHOSE',
	'WOMAN',
	'YIELD',
	'YOUTH',
	'YOUNG',
];
